<template>
  <v-row class="fill-height fill-width ma-0 pa-0" justify="center">
    <v-col class="d-flex justify-center align-center ma-0 pa-0">
      <v-card width="100%" class="rounded-10" :color="color"
        @drop="e => $emit('drop', e)"
        @dragover.stop.prevent="$emit('dragover')" 
        @dragleave.stop.prevent="$emit('dragleave')"
        :elevation="isInModal ? 0 : undefined"
        >
        <div :class="{ 'static-header': isHeaderFixed }" :style="headerFixStyle" >
          <v-card-title class="primary--text text--darken-2 py-1 px-8 d-flex fixed-title-height " >
            <v-row class="align-center">
              <v-col class="flex-grow-1">
                <h1 class="app-page-card__header overflow-hidden">
                  <slot name="header" />
                </h1>
              </v-col>
              <div v-if="$slots['header-actions']" class="d-flex flex-shrink-1 pa-0">
                <v-spacer />
                <slot name="header-actions" />
              </div>
            </v-row>
          </v-card-title>
          <v-divider/>
          <v-card-subtitle class="primary--text text--darken-2 d-flex fixed-title-height pa-0 ma-0" v-if="$slots['tabs-title']" >
            <v-row class="ma-0 pa-0">
              <v-col cols="12" class="ma-0 pa-0">
                <slot name="tabs-title"/>
              </v-col>
            </v-row>
          </v-card-subtitle>
        </div>
        <v-card-text class="pt-0 px-0">
          <slot />
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>


<script>
export default {
  name: 'AppPageCard',

  props: {
    color: {
      type: String,
      required: false
    },
    isInModal: {
      type: Boolean,
      required: false,
      default: false
    },
    isHeaderFixed: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  mounted() {
    // console.log(this.$slots)
    // console.log(this.$slots['header-actions'])
  },

  computed: {
    headerFixStyle() {
      let top = "0px";
      if (this.isHeaderFixed && this.isInModal) {
        top = "0px";
      }else if (this.isHeaderFixed && this.$slots['header-actions']) {
        if (this.$vuetify.breakpoint.name == 'xs' || this.$vuetify.breakpoint.name == 'sm') {
          top = "56px";
        }else {
          top = "61px";
        }
      }
      return { 'top': top };
    },
  },
    
}
</script>

<style>
  .fixed-title-height {
    min-height: 56px;
  }
  .app-page-card__header {
    font-size: 1.25rem;
    font-weight: 500;
    letter-spacing: 0.0125em;
    line-height: 2rem;
    color: #66359B;
  }
  .tabs-title-div-bck {
    background: #F8F8FA;
  }

  @media screen and (max-width: 960px) {
    .app-page-card__header {
      font-size: 1.1rem;
    }
  }
  .static-header {
    z-index: 1;
    background-color: white;
    position: sticky;
  }

  .rounded-10 {
    border-radius:10px !important;
  }

</style>